<template>
  <vs-popup class="formula_note_update_popup"
            id="popup"
            title="FORMULATIONS QC TEST UPDATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="flash_point" name="flash_point" rules="required" v-slot="{ errors }">
                <small class="label">Flash point</small>
                <vs-input type="text" v-model="form.flash_point" class="w-full"  name="flash_point" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="appearance" name="appearance" rules="required" v-slot="{ errors }">
                <small class="label">Appearance</small>
                <vs-input type="text" v-model="form.appearance" class="w-full"  name="appearance" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3" v-if="type === 'liquid'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="refractive_index" name="refractive_index" rules="required" v-slot="{ errors }">
                <small class="label">Refractive index</small>
                <vs-input type="text" v-model="form.refractive_index" class="w-full"  name="refractive_index" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="specific_gravity" name="specific_gravity" rules="required" v-slot="{ errors }">
                <small class="label">Specific gravity</small>
                <vs-input type="text" v-model="form.specific_gravity" class="w-full"  name="specific_gravity" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="type === 'liquid'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="ph" name="ph" rules="ph_value" v-slot="{ errors }">
                <small class="label">pH</small>
                <vs-input type="text" v-model="form.ph" class="w-full"  name="ph" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="odour" name="odour" rules="required" v-slot="{ errors }">
                <small class="label">Odour</small>
                <vs-input type="text" v-model="form.odour" class="w-full"  name="odour" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="taste" name="taste" rules="required" v-slot="{ errors }">
                <small class="label">Taste</small>
                <vs-input type="text" v-model="form.taste" class="w-full"  name="taste" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="brix" name="ph" rules="" v-slot="{ errors }">
                <small class="label">Brix</small>
                <vs-input type="text" v-model="form.brix" class="w-full"  name="ph" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="dosage" name="dosage" rules="" v-slot="{ errors }">
                    <small class="label">Max Dosage</small>
                    <vs-input type="text" v-model="form.dosage" name="dosage" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                              />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="notes" name="notes" rules="required" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save changes</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {}
    }
  }

export default {
  name: 'QcTestUpdateFormulationPopUp',
  data () {
    return initialState()
  },
  props: {
    type: {type: String, default: ''}
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        await this.loadQcTest()
        this.open = true
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async onClickCreate () {
      const vue = this;
      try {
        this.$vs.loading();
        await FormulationsRepository.updateFormulaQcTest(this.id, this.form)
        this.showSuccessMessage('Formulation qc test updated');
        await vue.$parent.refreshData()
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async loadQcTest() {
      this.$vs.loading()
      const {data} = (await FormulationsRepository.getQcTestDetails(this.id)).data
      this.form =  data
      this.$vs.loading.close()
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .formula_note_update_popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
</style>
